import {AppInsightsAdapter} from '@hconnect/common/logging'
import {FundamentalThemeInitializer} from '@hconnect/refraplanner/src/modules/common/providers/FundamentalThemeInitializer'
import {ErrorBoundary, hpTheme} from '@hconnect/uikit/src/lib2'
import {
  FundamentalContextProvider,
  ThemeProvider as FundamentalThemeProvider,
  ToastContainer
} from '@hm/fundamental'
import {ThemeProvider} from '@mui/material'
import {createRoot} from 'react-dom/client'
import {RouterProvider, createBrowserRouter} from 'react-router'

import './index.css'
import {checkAndEnableMockIfRequired} from './__mock__/registerMocks'
import {registerDomainOverride} from './api/domainOverride'
import {AppRoutes} from './App'
import {initLocalization} from './localization'

initLocalization()
checkAndEnableMockIfRequired()
registerDomainOverride()
AppInsightsAdapter.init()
// Tracking information and logs will be sent to azure
AppInsightsAdapter.allowTracking()

const rootElement = document.getElementById('root')
const root = createRoot(rootElement as HTMLElement)
const router = createBrowserRouter(AppRoutes)

root.render(
  <ThemeProvider theme={hpTheme}>
    <ErrorBoundary
      apology="We're sorry, something went wrong."
      resetText="Click here to start over"
    >
      <FundamentalContextProvider>
        <FundamentalThemeProvider>
          <FundamentalThemeInitializer />
          <ToastContainer />
          <RouterProvider router={router} unstable_useTransitions={false} />
        </FundamentalThemeProvider>
      </FundamentalContextProvider>
    </ErrorBoundary>
  </ThemeProvider>
)
